import { serviceRequest } from 'utils/http';
import { ReferralService } from 'common/api';

export function getScreenerAPI(id: string) {
  return serviceRequest(() =>
    ReferralService.referralControllerGetScreenerForCurrentUser(id)
  );
}
